import { Component, ChangeDetectionStrategy } from "@angular/core";
import { StorageService, UserService, StorageKeys, environment, LanguageService } from "@mypxplat/xplat/core";
import { AppBaseComponent, AppService, AvoService, ReftagService, ScriptService } from "@mypxplat/xplat/web/core";
import { SwitchLanguageComponent } from "@mypxplat/xplat/web/features";
import { TranslateService } from "@ngx-translate/core";
import { takeUntil } from "rxjs";
import moment from "moment";

// xplat

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: "myp-root",
  templateUrl: "./app.component.html",
  standalone: false,
})
export class AppComponent extends AppBaseComponent {
  constructor(
    userService: UserService,
    public appService: AppService,
    public avoService: AvoService,
    private _storageService: StorageService,
    private _translateService: TranslateService,
    private _scriptService: ScriptService,
    public reftagService: ReftagService,
    private _languageService: LanguageService
  ) {
    super(userService);
    this.appService.app = "presonus_connect";
    this.userService.appId = "presonus_connect";
    this.appService.title = "PreSonus Connect";
    this.appService.showLangSwitcher$.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.appService.showModal(SwitchLanguageComponent, { size: "lg", ariaLabelledBy: "modal-title" });
    });
  }

  ngOnInit() {
    if (this.env.features.cookie_management) this._scriptService.loadScript("osano");
    if (this.env.production) this._scriptService.loadScript("googletagmanager");
    this._languageService.initializeLanguage(this.user);
    this.avoService.initAvoFunctions(environment.avo.connectKey, "PreSonus Connect", "1.0.0.");
  }
}
